import { useMutation } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { queryClient } from '../api/client';
import { driverApi } from '../services/driverApi';

interface UpdateCallStatusData {
  callId: string;
  status: 'NEW' | 'PENDING' | 'DISPATCHED' | 'ON_SCENE' | 'TOWING' | 'COMPLETED' | 'CANCELED' | 'FAILED';
  version?: number; // Optional version for concurrency control
}

export const useUpdateCallStatus = () => {
  const { getAccessTokenSilently } = useHybridAuth();

  return useMutation({
    mutationFn: async (data: UpdateCallStatusData) => {
      const token = await getAccessTokenSilently();
      driverApi.setAuthToken(token);
      return driverApi.updateCallStatus(data.callId, data.status, data.version);
    },
    onSuccess: () => {
      // Invalidate and refetch calls data
      queryClient.invalidateQueries({ queryKey: ['driver-calls'] });
    },
  });
}; 